const Screens = {
  xsmall: '360px',
  small: '768px',
  medium: '992px',
  large: '1200px',
  xlarge: '1600px',
};

export default Screens;
